const LOCAL_STORAGE = {
  APP_USER: 'Avive-user',
  ACCOUNT: 'Account',
  MAPPING_DATA: 'mappingData',
  }

export {
  LOCAL_STORAGE
}
